import {Dispatch} from "redux";
import {UserActionType} from "../../reducers/userReducer/types";
import {
    Login,
    removeTokens,
    setAccessToken,
    setRefreshToken,
    Register, ConfirmEmail, Profile, Status,
    GetAllUsers,
    GetAllRoles,
    AddUser,
    DeleteUser,
    EditUser,
    UpdateRoles, ChangePassword, ForceLogin, saveOldCredentials, loadOldCredentials, removeOldCredentials
} from "../../../services/api-user-service";
import {jwtDecode} from "jwt-decode";
import {RESET_APP} from "../../store";

export const LoginUser = (user: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await Login(user);
            const {response} = data;

            const {token, refreshToken, message} = response;
            removeTokens();
            setAccessToken(token);
            setRefreshToken(refreshToken);
            AuthUser(token, message, dispatch);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: response.message,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};


export const AuthUser = (
    token: string,
    message: string,
    dispatch: Dispatch
) => {
    const decodedToken = jwtDecode(token) as any;
    if(decodedToken.role && typeof decodedToken.role === 'string')
        decodedToken.role = [decodedToken.role];
    dispatch({
        type: UserActionType.LOGGED_IN,
        payload: {
            message,
            decodedToken,
        },
    });
};

export const LogOut = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            removeOldCredentials();
            removeTokens();
            dispatch({
                type: UserActionType.LOGGED_OUT,
            });
        } catch {
        }
    };
};


export const RegisterUser = (user: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await Register(user);
            const {response} = data;
            console.log("Register response:", response);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: response.message,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};


export const ConfirmEmailAsync = (confirmData: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await ConfirmEmail(confirmData);
            const {response} = data;
            console.log("Register response:", response);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: response.message,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};


export const ProfileAsync = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await Profile();
            const {response} = data;
            console.log("Profile response:", response);
            dispatch({
                type: UserActionType.PROFILE_LOADED,
                payload: response,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};


export const StatusAsync = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await Status();
            const {response} = data;
            console.log("Profile response:", response);
            dispatch({
                type: UserActionType.STATUS_LOADED,
                payload: response,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};



export const ForceLoginUser = (user: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: UserActionType.START_REQUEST});
            const data = await ForceLogin(user);
            const {response} = data;

            const {token, refreshToken, message} = response;
            saveOldCredentials();
            removeTokens();
            setAccessToken(token);
            setRefreshToken(refreshToken);
            dispatch({ type: RESET_APP });
            AuthUser(token, message, dispatch);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: response.message,
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const UnloadForceLogin = () => {
    return async (dispatch: Dispatch) => {
        try {
            const tokens = loadOldCredentials();
            removeOldCredentials();
            removeTokens();
            setAccessToken(tokens.accessToken);
            setRefreshToken(tokens.refreshToken);
            dispatch({ type: RESET_APP });
            AuthUser(tokens.accessToken, tokens.refreshToken, dispatch);
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
}

export const GetAllUsersAsync = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            const data = await GetAllUsers();
            const { response } = data;
            dispatch({
                type: UserActionType.GET_ALL_USERS,
                payload: response,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const GetAllRolesAsync = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            const data = await GetAllRoles();
            const { response } = data;
            dispatch({
                type: UserActionType.GET_ALL_ROLES,
                payload: response,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const AddUserAsync = (user: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            await AddUser(user);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const DeleteUserAsync = (id: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            await DeleteUser(id);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const EditUserAsync = (user: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            await EditUser(user);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const UpdateRolesAsync = (id: string, roles: string[]) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            await UpdateRoles(id, roles);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const ChangePasswordAsync = (data: any) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UserActionType.START_REQUEST });
            await ChangePassword(data);
            dispatch({
                type: UserActionType.FINISH_REQUEST,
            });
        } catch (error) {
            dispatch({
                type: UserActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};
